import React, { useState, useEffect } from "react";
import "./HomePage.css";

// Import Carousel and its CSS
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

// Web images
import slider3Web from "../assets/slider3.jpg";
import slider1Web from "../assets/slider1.jpg";
import slider2Web from "../assets/slider2.jpg";

// Mobile images (only one available)
import slider1Mobile from "../assets/slider1-mobile.jpg";

function HomePage() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Use only available images
  const sliderImages = isMobile
    ? [slider1Mobile] // only one for mobile
    : [slider3Web, slider1Web, slider2Web]; // multiple for web

  return (
    <div className="home-page">
      {/* હીરો સ્લાઇડર */}
      <section className="hero-slider">
        <Carousel
          autoPlay
          infiniteLoop={sliderImages.length > 1} // disable infinite loop if only one image
          showThumbs={false}
          showStatus={false}
          interval={5000}
          showIndicators={sliderImages.length > 1} // hide dots if single image
          showArrows={sliderImages.length > 1} // hide arrows if single image
        >
          {sliderImages.map((img, index) => (
            <div key={index}>
              <img src={img} alt={`slider-${index + 1}`} />
            </div>
          ))}
        </Carousel>
      </section>

      {/* સ્વાગત વિભાગ */}
      <section className="container welcome-section">
        <h2>નમસ્તે - સ્વાગત</h2>
        <p className="main-description">
          અમારી આધ્યાત્મિક પરિવારમાં આપનું સ્વાગત છે. અમે અમારી પારંપરિકતાને
          જાળવી રાખવા, સમુદાયના બંધનો મજબૂત કરવા અને ભક્તિપૂર્વક સેવા કરવા માટે
          પ્રતિબદ્ધ છીએ. અમારી શ્રદ્ધા, સંસ્કૃતિ અને એકતાના સફરમાં અમારો સામેલ
          થાઓ.
        </p>

        <div className="features">
          <div className="feature">
            <span className="icon">🙏</span>
            <h3>ભક્તિ</h3>
            <p>
              श्री राम નવધા ભક્તિ શ્રી રામચરિતમાનસમાં "નવધા ભક્તિ"વર્ણવતા
              ગોસ્વામી તુલસીદાસ કહે છે કે... → પહેલી ભક્તિ એટલે સંતોનો સત્સંગ.
              બીજી ભક્તિ એટલે ભગવાન શ્રી રામની કથામાં પ્રેમ. ત્રીજી ભક્તિ એટલે
              અભિમાન રહિત જીવન જીવવું. * ચોથી ભક્તિ એટલે કપટ છોડી રઘુનાથના ગુણ
              સમૂહનું ગાન કરવું. પાંચમી ભક્તિ એટલે શ્રી રામના મંત્રનો
              વિશ્વાસપૂર્વક જાપ. છઠ્ઠીભક્તિ એટલે ઈન્દ્રિયોનો નિગ્રહ. સાતમી ભક્તિ
              એટલે જગતમાત્રમાં સમભાવ રાખી જીવન જીવવું. આઠમી ભક્તિ એટલે જે કંઈ
              પ્રાપ્ત થાય એમાં સંતોષ માનવો. નવમી ભક્તિ એટલે સરળતા અને સર્વની
              સાથે કપટ રહિત વર્તન કરવું તેમજ જીવનની કોઈપણ અવસ્થામાં હર્ષ અથવા તો
              વિશ્વાસથી દૂર રહેવું એટલે કે જીવનમાં સાક્ષીભાવ હોવું. "સારો સ્વભાવ
              અને ઉત્તમ ચારિત્ર સાથે કર્મમાં વૈરાગ્ય પણું (નિષ્કામ કર્મ) રાખી
              નિરંતર સંત પુરુષના આદેશ સાથે ધર્મમાં જોડાઈને રહેવું.સ્વપ્નમાં પણ
              પાર માટે કોઈ પરિણામો મળ્યાં નથી.
            </p>
          </div>
          <div className="feature">
            <span className="icon">📚</span>
            <h3>વારસો</h3>
            <p>
              જીવન જીવવાનો મુખ્ય ઉદ્દેશ માનવ સાચો માનવ બની એકબીજા સાથે નિકખાલસ
              અને પ્રમ ભર્યો વર્તાવ કરે, ઈશ્વરની ભકિત અને એકબીજા પર કૃપા કરે છે.
              પૃથ્વી પર મનુષ્યની ઉત્પત્તિ અનાયાસે નથી...!! એક બહુ મોટા હેતુસર
              તેને પૃથ્વી પર મોકલવામાં આવેલ છે... જેથી મુખ્ય હેતુ ઈશ્વરની ભકિત
              અને સત્કાર્ય, એકબીજા સાથે કરૂણા, ભાઈચારો, ભુખ્યાને અન્ન, વસ્ત્ર
              અને જીવો તેમજ જીવવા દો ની ભાવના સાથે જીવી, જીવનને અનમોલ બનાવવાનું
              કામ કરે છે. !!
            </p>
          </div>
          <div className="feature">
            <span className="icon">🤝</span>
            <h3>સમુદાય</h3>
            <p>એકતા અને એકતાનું અભ્યાસ</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HomePage;
